import React from 'react';
import PropTypes from 'prop-types';
import { SFEntityID, SFConnection, SFNotification } from 'utils/types';
import css from './ConnectionSchedulerView.css';
import ConnectionPlaceholder from 'serviceCatalog/connectionProfile/ConnectionPlaceholder';
import Scheduler from '../Scheduler';
import ScrollToTopOnMount from 'common/ScrollToTopOnMount';
import ConnectionHeader from 'serviceCatalog/connectionProfile/ConnectionHeader';
import { isEmpty } from 'lodash';
import ProfileNotFound from '../../ProfileNotFound';

export default class ConnectionSchedulerView extends React.Component {

  get content() {
    if ( !this.props.hasFetched ) return <ConnectionPlaceholder />;
    if ( isEmpty(this.props.connection) ) {
      return <ProfileNotFound renderNotification={this.props.notification.render} />;
    }
    return (
      <Scheduler
        id={this.props.connection.personId}
        partyId={this.props.partyId}
        isConnection
        name={this.props.connection.fullName}
        notification={this.props.notification}
        userTimeZone={this.props.userTimeZone}
        header={(
          <ConnectionHeader
            officeHours={this.props.connection.officeHours}
            personId={this.props.connection.personId}
            uuid={this.props.connection.uuid}
            fullName={this.props.connection.fullName}
            roles={this.props.connection.roles}
            title={this.props.connection.title}
            photoAvailable={this.props.connection.photoAvailable}
          />
        )}
      />
    );
  }

  render() {
    return (
      <div className={css['container']}>
        <ScrollToTopOnMount />
        {this.content}
      </div>
    );
  }
}

ConnectionSchedulerView.propTypes = {
  connection: PropTypes.shape(SFConnection),
  hasFetched: PropTypes.bool.isRequired,
  partyId: SFEntityID.isRequired,
  notification: SFNotification.isRequired,
  userTimeZone: PropTypes.string.isRequired
};
